"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.pruneClientOnlyBlockFields = void 0;
const lodash_1 = require("lodash");
const constants_1 = require("../constants");
/**
 * Remove block fields that are not allowed to be sent to the client
 *
 * @returns - the filtered block as Partial<Block>
 */
const pruneClientOnlyBlockFields = (block) => {
    const omittedBlock = (0, lodash_1.omit)(block, [...constants_1.ILLEGAL_BLOCK_FIELDS, ...constants_1.READ_ONLY_CLIENT_BLOCK_FIELDS]);
    return omittedBlock;
};
exports.pruneClientOnlyBlockFields = pruneClientOnlyBlockFields;
//# sourceMappingURL=filterObject.js.map